module.exports = __webpack_public_path__ + "static/media/pressure_washing.38725efe.jpg";